import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hall-one',
  templateUrl: './hall-one.component.html',
  styleUrls: ['./hall-one.component.scss']
})
export class HallOneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
